import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Chip, slug } from "@/components/Chip";

export const ReasonDialog = ({ open, onOpenChange, title, description, options, onSubmit, testPrefix, cta = "Send" }) => {
  const [reason, setReason] = useState(options[0]);
  const [note, setNote] = useState("");
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="z-[1250] sm:max-w-md" data-testid={`${testPrefix}-modal`}>
        <DialogHeader>
          <DialogTitle className="text-xl">{title}</DialogTitle>
          {description && <DialogDescription>{description}</DialogDescription>}
        </DialogHeader>
        <div className="flex flex-wrap gap-2">
          {options.map((o) => <Chip key={o} testId={`${testPrefix}-option-${slug(o)}`} active={reason === o} onClick={() => setReason(o)}>{o}</Chip>)}
        </div>
        <textarea data-testid={`${testPrefix}-note`} value={note} onChange={(e) => setNote(e.target.value)} placeholder="Anything to add? (optional)" rows={3}
          className="w-full rounded-lg border border-stone-300 p-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#2F7D55]/40" />
        <button data-testid={`${testPrefix}-submit`} onClick={() => { onSubmit(reason, note); setNote(""); }}
          className="w-full bg-[#2F7D55] hover:bg-[#23603F] text-white font-semibold py-2.5 rounded-xl transition-colors">{cta}</button>
      </DialogContent>
    </Dialog>
  );
};
